import React from 'react'
import styled from 'styled-components'
import { color, spacing, border, fontSize } from '../theme'
import { Avatar } from '../atoms/Avatar'
import PropTypes from 'prop-types'

const LabelWrapper = styled.label`
   background: ${color.white};
   padding: ${spacing.m} ${spacing.l};
   border-radius: ${border.radius};
   display: flex;
   align-items: center;
   width: 100%;
   margin-bottom: ${spacing.m};
   cursor: pointer;

   ${props =>
      props.active
         ? `
      border: 2px solid ${color.text}; 
    `
         : `
      border: 2px dashed ${color.disabledBg};
    `}
`

const Name = styled.span`
   padding-left: ${spacing.l};
   font-weight: bold;
   font-size: ${fontSize.ml};
`

export const ChildBlock = ({ name, selected, childOrder, ...props }) => (
   <LabelWrapper active={selected} {...props}>
      <Avatar childOrder={childOrder} name={name} size={'large'} />
      <Name>{name}</Name>
   </LabelWrapper>
)

ChildBlock.propTypes = {
   /**
    * Child name both first and lastname
    */
   name: PropTypes.string.isRequired,
   /**
    * is Choosen, true or false
    */
   isChoosen: PropTypes.bool.isRequired,
   /**
    * Child order in list
    */
   childOrder: PropTypes.number
}

ChildBlock.defaultProps = {
   name: 'First Lastname',
   isChoosen: false,
   childOrder: 1
}
